import { SearchTerm } from "./SearchTerm";

const PersonAccessReportSearch: SearchTerm[] = [
    {
        heading: "All",
        accessor: "search",
        searchOnName: "search",
        translationKey: "all"
    },
    {
        heading: "Door",
        accessor: "door",
        searchOnName: "locationName",
        translationKey: "door"
    },
    {
        heading: "Access Group",
        accessor: "accessGroup",
        searchOnName: "accessGroupName",
        translationKey: "accessGroup"
    },
    {
        heading: "Access Area",
        accessor: "area",
        searchOnName: "areaName",
        translationKey: "accessArea"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "siteName",
        translationKey: "site"
    },
    {
        heading: "Building",
        accessor: "building",
        searchOnName: "buildingName",
        translationKey: "building"
    },
    {
        heading: "Floor",
        accessor: "floor",
        searchOnName: "floorName",
        translationKey: "floor"
    },
]

export default PersonAccessReportSearch;
